module.exports = __webpack_public_path__ + "img/icon-speed-9.0860316e.svg";